const loadImageFromBase64 = (base64String) => {
  return new Promise((resolve, reject) => {
    const img = new Image()

    img.src = base64String

    img.onload = () => {
      resolve(img)
    }

    img.onerror = (error) => {
      reject(error)
    }
  })
}

const convertImageDataToDataUrl = async (base64String) => {
  try {
    const img = await loadImageFromBase64(base64String)

    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')

    // Set the canvas size to the original image size
    canvas.width = img.width
    canvas.height = img.height

    // Draw the image onto the canvas
    context.drawImage(img, 0, 0, canvas.width, canvas.height)

    // Convert canvas to data URL
    const dataUrl = canvas.toDataURL('image/png')
    return dataUrl
  } catch (error) {
    console.error('Error converting base64 to data URL:', error)
    return null
  }
}

export const convertToDataUrl = async (data) => {
  const base64String = data.startsWith('data:image/')
    ? data
    : `data:image/png;base64,${data}`
  const dataUrl = await convertImageDataToDataUrl(base64String)
  return dataUrl
}

export const getImageDataFromFileUrl = (fileUrl, targetFileSizeKB = 100) => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas')
    const img = new Image()
    img.crossOrigin = 'Anonymous'

    img.onload = function () {
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')

      // Draw the image without scaling
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

      // Function to adjust quality and ensure size < 100KB
      const compressImage = (quality) => {
        let dataUrl = canvas.toDataURL('image/jpeg', quality)

        const base64Length = dataUrl.length - 'data:image/jpeg;base64,'.length
        const fileSizeBytes = (base64Length * 3) / 4
        const fileSizeKB = fileSizeBytes / 1024

        if (fileSizeKB > targetFileSizeKB && quality > 0.1) {
          // Reduce quality and retry if file size is too big
          return compressImage(quality - 0.05)
        }

        return dataUrl
      }

      const finalDataUrl = compressImage(0.8) // Start with 80% quality

      const imgElement = new Image()

      imgElement.onload = function () {
        const canvasFinal = document.createElement('canvas')
        canvasFinal.width = img.width
        canvasFinal.height = img.height
        const ctxFinal = canvasFinal.getContext('2d')
        ctxFinal.drawImage(imgElement, 0, 0)

        const imageData = ctxFinal.getImageData(
          0,
          0,
          canvasFinal.width,
          canvasFinal.height
        )
        resolve(imageData)
      }

      imgElement.src = finalDataUrl
    }

    img.src = fileUrl
  })
}

const encodings =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

export const base64ArrayBuffer = (arrayBuffer) => {
  const bytes = new Uint8Array(arrayBuffer)
  const byteLength = bytes.byteLength
  const byteRemainder = byteLength % 3
  const mainLength = byteLength - byteRemainder

  let base64 = ''
  let a, b, c, d
  let chunk

  // Main loop deals with bytes in chunks of 3
  for (let i = 0; i < mainLength; i = i + 3) {
    // Combine the three bytes into a single integer
    chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]

    // Use bitmasks to extract 6-bit segments from the triplet
    a = (chunk & 16515072) >> 18 // 16515072 = (2^6 - 1) << 18
    b = (chunk & 258048) >> 12 // 258048   = (2^6 - 1) << 12
    c = (chunk & 4032) >> 6 // 4032     = (2^6 - 1) << 6
    d = chunk & 63 // 63       = 2^6 - 1

    // Convert the raw binary segments to the appropriate ASCII encoding
    base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d]
  }

  // Deal with the remaining bytes and padding
  if (byteRemainder === 1) {
    chunk = bytes[mainLength]

    a = (chunk & 252) >> 2 // 252 = (2^6 - 1) << 2

    // Set the 4 least significant bits to zero
    b = (chunk & 3) << 4 // 3   = 2^2 - 1

    base64 += encodings[a] + encodings[b] + '=='
  } else if (byteRemainder === 2) {
    chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1]

    a = (chunk & 64512) >> 10 // 64512 = (2^6 - 1) << 10
    b = (chunk & 1008) >> 4 // 1008  = (2^6 - 1) << 4

    // Set the 2 least significant bits to zero
    c = (chunk & 15) << 2 // 15    = 2^4 - 1

    base64 += encodings[a] + encodings[b] + encodings[c] + '='
  }

  return base64
}
